// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2-ZgO","footer":"ModalInfo_footer__1CTgg"};